import analyticsHelpers from '../helpers/analytics-helpers';

// Initialize the GA events directive.
const gaEvent = {
  bind(el, binding) {
    el.addEventListener('click', () => {    
      analyticsHelpers.gaEvent(
        emptyString(binding.value.category),
        emptyString(binding.value.action), 
        emptyString(binding.value.label)
      );
    }, false);
  },
};


const emptyString = (value) => {
  if(value === "")
  {
    return '(not set)';
  }
  return value;
}

export {
  gaEvent,
};
